import { t } from '../../strings/i18n';
import { required } from '../../xform';
const paymentMethodConfig = (apiMachineRef) => {
    var _a, _b;
    const api = apiMachineRef.getSnapshot().context;
    const autopayStatus = api.autopayStatusQueryResult.data;
    let paymentMethod;
    if (autopayStatus.enrollment === true) {
        paymentMethod =
            ((_a = autopayStatus.paymentMethod) === null || _a === void 0 ? void 0 : _a.id) || ((_b = autopayStatus.paymentCardInfo) === null || _b === void 0 ? void 0 : _b.id);
    }
    return [
        'paymentMethod',
        paymentMethod,
        'ENABLED',
        [required(t('errors.paymentMethod'))]
    ];
};
export default paymentMethodConfig;
